module.exports = Object.freeze({
  R_ERROR: 'R_ERROR',
  R_LOADING: 'R_LOADING',
  R_RESET: 'R_RESET',
  R_SOCKET: 'R_SOCKET'
})
